"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rowPropType = exports.columnPropType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var columnProps = {
  key: _propTypes.default.string.isRequired,
  render: _propTypes.default.func,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  cellStyle: _propTypes.default.shape({}),
  cellContentStyle: _propTypes.default.shape({}),
  sorter: _propTypes.default.bool,
  sortFn: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.bool]),
  filters: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.default.string,
    label: _propTypes.default.string
  })),
  filtered: _propTypes.default.bool,
  filterSingle: _propTypes.default.bool,
  popupOnRight: _propTypes.default.bool,
  fixed: _propTypes.default.oneOf(['left', 'right']),
  selectedFilters: _propTypes.default.arrayOf(_propTypes.default.any)
};
columnProps.children = _propTypes.default.arrayOf(_propTypes.default.shape(columnProps));

var columnPropType = _propTypes.default.shape(columnProps);

exports.columnPropType = columnPropType;

var rowPropType = _propTypes.default.objectOf(_propTypes.default.any);

exports.rowPropType = rowPropType;